<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加节点配置</el-button
    >

    <el-dialog
      title="添加节点配置"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="线路zh" prop="zh">
          <el-input
            v-model.trim="ruleForm.zh"
            placeholder="请输入线路名称(中文) 例如 线路1"
          ></el-input>
        </el-form-item>
        <el-form-item label="线路en" prop="en">
          <el-input
            v-model.trim="ruleForm.en"
            placeholder="请输入线路名称(英文) 例如 line1"
          ></el-input>
        </el-form-item>
        <el-form-item label="线路名称" prop="lineUrl">
          <el-input
            v-model.trim="ruleForm.lineUrl"
            placeholder="请输入域名或地址 如 https://www.baidu.com"
          ></el-input>
        </el-form-item>
        <el-form-item label="测速请求地址" prop="checkInterface">
          <el-input
            v-model.trim="ruleForm.checkInterface"
            placeholder="请输入测速请求地址 如 https://www.xxx.com/login"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="国家区号" prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            placeholder="请输入国家区号，例如中国为86"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家码" prop="locale">
          <el-input
            v-model.trim="ruleForm.locale"
            placeholder="例如中国为CHN"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="启用状态" prop="status">
          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ValidateLineUrl } from "../../validate.js";

export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        zh: "",
        en: "",
        lineUrl: "",
        status: 0,
      },
      arr: [],
      result: false,
      rules: {
        zh: [
          {
            required: true,
            message: "请输入线路名称（zh）",
            trigger: "blur",
          },
          // { message: "请输入线路名称", trigger: "blur" },
        ],
        en: [
          { required: true, message: "请输入线路名称（en）", trigger: "blur" },
          //  { message: "不能为空", trigger: "blur" },
        ],

        lineUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
        ],
        checkInterface: [
          { required: true, message: "请输入测速请求地址", trigger: "blur" },
          //  { message: "不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions("nodeConfigStore", ["addOne", "getlist", "getUrlList"]),
    closeDialog() {
      this.resetForm("ruleForm");
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const obj = {
            ...this.ruleForm,
            status: Number(this.ruleForm.status),
          };
          const res = await this.addOne(obj);
          if (res.code == 0) {
            this.dialogVisible = false;
            this.getUrlList({ page: 1, size: 10 });
            this.ruleForm = {
              zh: "",
              en: "",
              lineUrl: "",
              status: 0,
            };
            this.$message.success("添加成功");
          } else {
            this.$message.console.error("添加失败，请重试");
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
